var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApproveFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10499_22294)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.000244141 7C0.000244141 5.14348 0.737742 3.36301 2.0505 2.05025C3.36325 0.737498 5.14373 0 7.00024 0C8.85676 0 10.6372 0.737498 11.95 2.05025C13.2627 3.36301 14.0002 5.14348 14.0002 7C14.0002 8.85652 13.2627 10.637 11.95 11.9497C10.6372 13.2625 8.85676 14 7.00024 14C5.14373 14 3.36325 13.2625 2.0505 11.9497C0.737742 10.637 0.000244141 8.85652 0.000244141 7H0.000244141ZM6.60078 9.996L10.6309 4.95787L9.90291 4.37547L6.46638 8.66973L4.03224 6.6416L3.43491 7.3584L6.60078 9.99693V9.996Z",
    fill: "#20A74E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10499_22294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0.000244141)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveFill);
export default __webpack_public_path__ + "static/media/approve_fill.203a067f9b7af711543c12d27772504b.svg";
export { ForwardRef as ReactComponent };